import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/theme/utils/app-validators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from 'src/app/app.service';
import { LoginserviceService } from 'src/app/services/loginservice.service';
import { Router } from '@angular/router';
import { NumeroCompte } from 'src/app/app.models';
import { Subscription } from 'rxjs';
import { NumeroCompteService } from 'src/app/services/numero-compte.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-mon-porte-monaie-valide",
  templateUrl: "./mon-porte-monaie-valide.component.html",
  styleUrls: ["./mon-porte-monaie-valide.component.scss"],
})
export class MonPorteMonaieValideComponent implements OnInit , OnDestroy {

  //Subscription
  numeroCompteSubscription: Subscription;

  public userIn: any;

  public numeroCompte: NumeroCompte;

  constructor(
    private router: Router,
    private numeroCompteService: NumeroCompteService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {

    const storageAuth = localStorage.getItem("user");
    
    if (storageAuth) {

      this.userIn = JSON.parse(storageAuth);

      this.getNumeroCompteOfUser();

    } else {

      this.router.navigate(["login"]);

    }

  }

  getNumeroCompteOfUser() {

    this.numeroCompteSubscription = this.numeroCompteService.numeroCompteOfUser(this.userIn.id).subscribe((response: any) => {

      if(response.numeroCompte) {

        this.numeroCompte = response.numeroCompte;

      } else {

        this.numeroCompte = new NumeroCompte({});

        this.toastr.info("Aucun N° IBAN n'a été ajouté pour le moment");

        this.router.navigate(["compte-utilisateur/mes-paiements/mon-porte-monaie"]);

      }

    })
  }

  ngOnDestroy(): void {
    
    this.numeroCompteSubscription.unsubscribe();

  }

}